var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"siffaDefaultLayout"},[_c('navMenu'),_c('backPageTop'),_c('router-view'),_c('pageBottom',{staticClass:"pageBottom"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }